import { render, staticRenderFns } from "./LoanRecords.vue?vue&type=template&id=348f8d42&scoped=true"
import script from "./LoanRecords.vue?vue&type=script&lang=js"
export * from "./LoanRecords.vue?vue&type=script&lang=js"
import style0 from "./LoanRecords.vue?vue&type=style&index=0&id=348f8d42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f8d42",
  null
  
)

export default component.exports